module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/column-2-152d8a118d076f7e633c9ef03a0cae9c.svg";